module.exports = __webpack_public_path__ + "img/znzz.888446c2.png";